import React from 'react'

const ResolutionScreenInformation = () => {
  return (
    <>
      <h2>Resolução</h2>
      <div className='information'>
        <h3>Resolução da tela:</h3>
        <span>
          {window.screen.width
            ? `${window.screen.width} x ${window.screen.height}`
            : 'Não encontrada'}
        </span>
      </div>
      <div className='information'>
        <h3>Resolução interna:</h3>
        <span>
          {window.innerWidth ? `${window.innerWidth} x ${window.innerHeight}` : 'Não encontrada'}
        </span>
      </div>
    </>
  )
}

export default ResolutionScreenInformation
